import { h, ComponentChildren } from 'preact'
import DropdownList from './DropdownList'
import Dropdown from './index'
import { GroupedItemsList, ItemsList } from './interfaces'

interface Props {
    type?: string,
    align: string,
    trigger: ComponentChildren,
    items: ItemsList | GroupedItemsList,
    displayListUpwards?: boolean,
    hasSearch?: boolean,
    triggerClass?: string
}

const DropdownControl = ({ type, align, trigger, items, displayListUpwards, hasSearch, triggerClass }: Props) => {

  return (
    <Dropdown
      class={'control-dropdown'}
      trigger={trigger}
      triggerClass={triggerClass}
    >
      <DropdownList
        displayListUpwards={displayListUpwards}
        type={type}
        align={align}
        items={items}
        hasSearch={hasSearch || false}
      />
    </Dropdown>
  )
}

export default DropdownControl
